export const TiersPageSkeleton = () => {
  return (
    <div className="p-8 w-full">
      <div className="flex justify-between items-center">
        <div className="animate-pulse rounded-md bg-skeleton h-8 w-44" />
        <div className="animate-pulse rounded-md bg-skeleton h-10 w-32" />
      </div>
      <div className="animate-pulse rounded-md bg-skeleton h-[600px] w-full mt-9" />
    </div>
  )
}
